<div
  class="marine-insurance-indicator"
  [ngClass]="{
    insured: isInsured,
    'marine-insurance-indicator-plain': isPlain,
    'marine-insurance-indicator-downloading': isDownloading,
    'marine-insurance-indicator-disabled': isDisabled
  }"
  nz-popover
  nzPopoverTrigger="hover"
  [nzPopoverContent]="insuranceTooltipTranslationText | translate"
  role="button"
  [attr.tabindex]="isDisabled ? -1 : 0"
  [attr.aria-disabled]="isDisabled"
  [attr.aria-label]="insuranceTooltipTranslationText | translate"
  (click)="onIndicatorClick()"
  (keydown.enter)="onIndicatorClick()"
  (keydown.space)="$event.preventDefault(); onIndicatorClick()"
>
  <img [src]="'/assets/icons/' + iconName" alt="" *ngIf="!isDownloading" />
  <i class="fa fa-spinner fa-spin marine-insurance-indicator-spinner" *ngIf="isDownloading"></i>
</div>

<a #insuranceCertificateLink class="d-none" download></a>
